import {
  DiscoveryApi,
  FetchApi,
  IdentityApi,
} from '@backstage/core-plugin-api';
import { ResponseError } from '@backstage/errors';
import type { TechRadarApi } from '@backstage-community/plugin-tech-radar';
import {
  TechRadarLoaderResponse,
  TechRadarLoaderResponseParser,
} from '@backstage-community/plugin-tech-radar-common';

type TechRadarRadarClientOptions = {
  discoveryApi: DiscoveryApi;
  fetchApi: FetchApi;
  identityApi: IdentityApi;
};

export class TechRadarRadarClient implements TechRadarApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;
  private readonly identityApi: IdentityApi;

  constructor(options: TechRadarRadarClientOptions) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
    this.identityApi = options.identityApi;
  }

  async load(id?: string): Promise<TechRadarLoaderResponse> {
    const apiUrl = await this.discoveryApi.getBaseUrl('tech-radar');
    const { token } = await this.identityApi.getCredentials();
    const url = new URL(`${apiUrl}/data`);

    if (id) {
      url.searchParams.set('id', id);
    }

    const response = await this.fetchApi.fetch(url.toString(), {
      headers: {
        'Content-Type': 'application/json',
        ...(token && { Authorization: `Bearer ${token}` }),
      },
    });

    if (!response.ok) {
      throw await ResponseError.fromResponse(response);
    }

    const payload = await response.json();
    const parsed = TechRadarLoaderResponseParser.safeParse(payload);
    if (!parsed.success) {
      throw new Error('Invalid tech radar response from backend.');
    }

    return parsed.data;
  }
}
